import { render } from "./OltDataPort.vue?vue&type=template&id=2605db28"
import script from "./OltDataPort.vue?vue&type=script&lang=js"
export * from "./OltDataPort.vue?vue&type=script&lang=js"

import "./OltDataPort.vue?vue&type=style&index=0&id=2605db28&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__